/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Device_Change_FailedInputs */

const en_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to change audio device: ${i?.error}`)
};

const fr_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du changement de périphérique audio : ${i?.error}`)
};

const de_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audiogerät konnte nicht gewechselt werden: ${i?.error}`)
};

const it_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile modificare il dispositivo audio: ${i?.error}`)
};

const ru_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось изменить аудиоустройство: ${i?.error}`)
};

const es_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo cambiar el dispositivo de audio: ${i?.error}`)
};

const zh_cn2_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更改音频设备失败：${i?.error}`)
};

const ja_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオデバイスの変更に失敗しました: ${i?.error}`)
};

const hi_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो डिवाइस बदलने में विफल: ${i?.error}`)
};

const pt_pt2_audio_recorder_device_change_failed = /** @type {(inputs: Audio_Recorder_Device_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao alterar o dispositivo de áudio: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to change audio device: {error}" |
*
* @param {Audio_Recorder_Device_Change_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_device_change_failed = /** @type {((inputs: Audio_Recorder_Device_Change_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Device_Change_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_device_change_failed(inputs)
	if (locale === "de") return de_audio_recorder_device_change_failed(inputs)
	if (locale === "it") return it_audio_recorder_device_change_failed(inputs)
	if (locale === "ru") return ru_audio_recorder_device_change_failed(inputs)
	if (locale === "es") return es_audio_recorder_device_change_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_device_change_failed(inputs)
	if (locale === "ja") return ja_audio_recorder_device_change_failed(inputs)
	if (locale === "hi") return hi_audio_recorder_device_change_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_device_change_failed(inputs)
	return en_audio_recorder_device_change_failed(inputs)
});